<div class="mat-like-stepper m-3" *ngIf="steps.length > 0">
  <ng-container *ngFor="let step of steps; let i = index">

    <!-- Step -->
    <div class="mat-step" [class.active]="activeStep >= i">
      <div class="circle">{{ i + 1 }}</div>
      <div class="label">{{ step.label }}</div>
    </div>

    <!-- Línea (excepto en el último) -->
    <div 
      *ngIf="i < steps.length - 1" 
      class="mat-line" 
      [class.active]="activeStep > i">
    </div>

  </ng-container>
</div>
